import React from 'react';
import { match } from 'ts-pattern';
import { AddToCartButton, DishAvailabilityStatus } from '../AddToCartButton';
import { DishQuantityPicker } from '../DishQuantityPicker';
import { AddToCartButtonContainer, BottomContainer, ItemDetailsButton } from './styles';

export enum ConsumerOrderDishSelectionItemFormat {
  ORDER,
  FREE_DELIVERY_MODAL,
}

interface DishActionsSectionProps {
  format: ConsumerOrderDishSelectionItemFormat;
  quantity: number;
  availability: DishAvailabilityStatus;
  onDetailsClick: () => void;
  onIncrement: () => void;
  onDecrement: () => void;
  onAddToCart: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const DishActionsSection: React.FC<DishActionsSectionProps> = ({
  format,
  quantity,
  onDetailsClick,
  availability,
  onIncrement,
  onDecrement,
  onAddToCart,
}) =>
  match(format)
    .with(ConsumerOrderDishSelectionItemFormat.ORDER, () => (
      <BottomContainer>
        {quantity ? (
          <DishQuantityPicker quantity={quantity} onIncrement={onIncrement} onDecrement={onDecrement} />
        ) : (
          <AddToCartButton availability={availability} onClick={onAddToCart} />
        )}
        <ItemDetailsButton onClick={onDetailsClick}>Item Details</ItemDetailsButton>
      </BottomContainer>
    ))
    .with(ConsumerOrderDishSelectionItemFormat.FREE_DELIVERY_MODAL, () => (
      <AddToCartButtonContainer>
        <AddToCartButton availability={availability} onClick={onAddToCart} width='100%' />
      </AddToCartButtonContainer>
    ))
    .otherwise(() => <></>);
